import { jsx } from 'panel';
import { SelectEl } from 'common/components/select';
import { ButtonEl } from 'common/components/button';
import { ButtonSize, ButtonTheme } from 'common/components/button/constants';
import { SvgIconEl } from 'common/components/svg-icon';
export function template() {
  var _a, _b, _c;

  const isModal = this.attr("is-modal");
  return jsx("div", null, !isModal && jsx("div", {
    sel: '.step-title'
  }, "Enter Payment Info"), jsx("div", {
    sel: '.payment-details-form',
    class: {
      'payment-info-border': !isModal
    }
  }, jsx("div", {
    sel: '.input-row'
  }, jsx("div", {
    sel: '.stripe-input.card-number'
  }, jsx("label", {
    for: 'cardNumber',
    sel: '.mp-font-size-medium'
  }, "Card number"), jsx("div", {
    sel: '#cardNumber.input'
  }), jsx("div", {
    sel: '.error-message'
  }, (_a = this.state.errors) === null || _a === void 0 ? void 0 : _a.cardNumber)), jsx("div", {
    sel: '.stripe-input.expiration'
  }, jsx("label", {
    for: 'cardExpiry',
    sel: '.mp-font-size-medium'
  }, "Expiration"), jsx("div", {
    sel: '#cardExpiry.input'
  }), jsx("div", {
    sel: '.error-message'
  }, (_b = this.state.errors) === null || _b === void 0 ? void 0 : _b.cardExpiry))), jsx("div", {
    sel: '.input-row'
  }, jsx("div", {
    sel: '.stripe-input.cvc'
  }, jsx("label", {
    for: 'cardCvc',
    sel: '.mp-font-size-medium'
  }, "CVV"), jsx("div", {
    sel: '#cardCvc.input'
  }), jsx("div", {
    sel: '.error-message'
  }, (_c = this.state.errors) === null || _c === void 0 ? void 0 : _c.cardCvc)), jsx("div", {
    sel: '.stripe-input.country'
  }, jsx("label", {
    for: 'cardCountry',
    sel: '.mp-font-size-medium'
  }, "Country"), jsx(SelectEl, {
    sel: '#cardCountry',
    attrs: {
      'selected-option': this.helpers.getSelectedCountry(),
      'menu-height': 300
    },
    props: {
      sections: this.helpers.getCountriesItems()
    },
    on: {
      change: this.helpers.handleCountrySelectChange
    }
  })), this.helpers.POSTAL_CODE_COUNTRIES.has(this.state.selectedCountryCode) && jsx("div", {
    sel: '.stripe-input.postal-code'
  }, jsx("label", {
    for: 'postal-code',
    sel: '.mp-font-size-medium'
  }, "Postal Code"), jsx("input", {
    type: 'text',
    sel: '#postal-code',
    class: Object.assign({
      input: true
    }, this.state.selectedPostalCode && {
      invalid: this.state.errors.postalCode,
      complete: !this.state.errors.postalCode
    }),
    props: {
      value: this.state.selectedPostalCode,
      placeholder: "12345"
    },
    on: {
      change: this.helpers.handlePostalCodeChange,
      input: this.helpers.handlePostalCodeInput
    }
  }), jsx("div", {
    sel: '.error-message'
  }, this.state.errors.postalCode)))), isModal ? jsx("div", {
    sel: '.review-btn-area.modal'
  }, jsx(ButtonEl, {
    attrs: {
      theme: ButtonTheme.Secondary,
      size: ButtonSize.Large
    },
    on: {
      click: () => this.dispatchEvent(new CustomEvent("cancel-modal"))
    }
  }, "Cancel"), jsx(ButtonEl, {
    attrs: {
      theme: ButtonTheme.Primary,
      size: ButtonSize.Large,
      disabled: this.helpers.disableReviewButton()
    },
    on: {
      click: () => this.makeRequest()
    }
  }, "".concat(this.state.reviewBtnLoading ? "Processing" : "Update"))) : jsx("div", {
    sel: '.review-btn-area'
  }, this.attr("editing-card-info") && jsx(ButtonEl, {
    attrs: {
      theme: ButtonTheme.Secondary,
      size: ButtonSize.Large
    },
    on: {
      click: () => this.dispatchEvent(new CustomEvent("toggle-edit-card"))
    }
  }, "Cancel"), jsx(ButtonEl, {
    attrs: {
      theme: ButtonTheme.Primary,
      role: "button",
      tabindex: 0,
      disabled: this.helpers.disableReviewButton(),
      size: ButtonSize.Large
    },
    on: {
      click: () => this.passSubmitPB2()
    }
  }, "".concat(this.state.reviewBtnLoading ? "Processing" : "Review")), this.attr("show-not-charged-today") && jsx("div", {
    sel: '.info-icon-area'
  }, jsx(SvgIconEl, {
    attrs: {
      icon: "info"
    },
    sel: '.info-icon'
  }), jsx("span", null, "Your card will not be charged today, but we do require a card on file."))));
}